/* eslint-disable react/no-multi-comp */
import React, { useState } from 'react';
import { bool, oneOf, number, string } from 'prop-types';
import ReactDatePicker from 'react-datepicker';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.scss';
import { es } from 'date-fns/locale';
import { formatDate, isValidDate } from '@Shared/Utils/dateHelpers';
import { GLOBAL } from '@Config/global';

// Registrar locale español
registerLocale('es', es);
setDefaultLocale('es');

const DatePicker = ({ defaultValue = '', birthday = false, firstDayOfWeek = 0, inputIconPosition = "after", numberOfMonths = 1, noDefaultValue = false, displayFormat = "dd/MM/yyyy", id, disabled = false, smallPrint = '', errorMsg = '', imgSrc = '', onChange, readOnly }) => {
  const { COMMON_SEARCH_FORM } = GLOBAL;
  
  // Convertir defaultValue a Date object si existe
  const parseDate = (dateString) => {
    if (!dateString) return null;
    
    // Si el formato es dd/MM/yyyy, parsear manualmente
    if (dateString.includes('/')) {
      const parts = dateString.split('/');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Los meses en JS son 0-11
        const year = parseInt(parts[2], 10);
        const date = new Date(year, month, day);
        return isNaN(date.getTime()) ? null : date;
      }
    }
    
    // Para otros formatos, intentar con el constructor normal
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? null : date;
  };
  
  const initialDate = parseDate(defaultValue) || (birthday ? new Date(new Date().getFullYear() - 60, 0, 1) : (noDefaultValue ? null : new Date()));
  
  const [date, setDate] = useState(initialDate);

  const handleDateChange = inputDate => {
    setDate(inputDate);
    onChange && onChange({
      target: {
        id: id,
        value: (inputDate ? formatDate(inputDate, 'yyyy/MM/dd') : ""),
        isValid: isValidDate(inputDate)
      }
    });
  }

  const CustomInput = React.forwardRef(({ value, onClick }, ref) => {
    // Formatear el valor para mostrarlo correctamente
    const displayValue = value && date ? formatDate(date, displayFormat) : value;
    
    return (
      <div className="react-datepicker__input-container">
        <input
          ref={ref}
          type="text"
          value={displayValue || ''}
          onClick={onClick}
          placeholder={COMMON_SEARCH_FORM.DATEPICKER_PLACEHOLDER}
          disabled={disabled}
          readOnly={readOnly || true} // Siempre readOnly para evitar edición manual
          className="form-control"
        />
        <i className={`bi bi-calendar ${disabled ? "" : "green-icon"} react-datepicker__calendar-icon`}></i>
      </div>
    );
  });

    return (
    <ReactDatePicker
      selected={date}
      onChange={handleDateChange}
      locale="es"
      dateFormat={displayFormat}
      customInput={<CustomInput />}
      disabled={disabled}
      readOnly={readOnly}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      calendarClassName="react-datepicker-custom"
    />
  );
}

DatePicker.propTypes = {
  birthday: bool,
  disabled: bool,
  displayFormat: string,
  firstDayOfWeek: number,
  id: string.isRequired,
  defaultValue: string,
  errorMsg: string,
  smallPrint: string,
  imgSrc: string,
  borderColor: string,
  maxLength: string,
  inputIconPosition: oneOf(["after", "before"]),
  numberOfMonths: number
}

export default DatePicker;
